// The one place the popular / gem line is written down (ticket 39).
// Books, the Settings card and Pipelines all read it from here. The database
// count (admin_popularity_counts) is handed these two numbers, never its own.

export const POPULAR_EDITIONS = 10;
export const POPULAR_RATINGS = 500;

export const POPULAR_LINE_TEXT = `Popular at ${POPULAR_EDITIONS}+ editions or ${POPULAR_RATINGS}+ ratings`;

export const POPULARITY_LABEL = { popular: 'Popular', gem: 'Gem', unknown: 'Unknown' };

// A missing reading is not a zero: null < 10 is true in JS, which would turn
// every unchecked book into the strongest gem. Both missing is its own answer.
const has = (n) => typeof n === 'number' && Number.isFinite(n);

// book: { edition_count, ratings_count, popularity_override } where
// popularity_override is null or { class: 'popular' | 'gem', reason }.
// A person's call beats the rule.
export function classifyPopularity(book) {
  const o = book?.popularity_override;
  if (o && (o.class === 'popular' || o.class === 'gem')) {
    return { cls: o.class, byHand: true, reason: o.reason || '' };
  }
  const e = book?.edition_count;
  const r = book?.ratings_count;
  if (!has(e) && !has(r)) return { cls: 'unknown', byHand: false, reason: '' };
  if ((has(e) && e >= POPULAR_EDITIONS) || (has(r) && r >= POPULAR_RATINGS)) return { cls: 'popular', byHand: false, reason: '' };
  return { cls: 'gem', byHand: false, reason: '' };
}

// The two raw readings, never combined: "48 editions · 1,203 ratings".
// A reading that is missing says so rather than showing 0. With neither,
// popularity_checked_at tells "looked up, nothing came back" from "never looked up".
export function readingsText(book) {
  const e = book?.edition_count;
  const r = book?.ratings_count;
  if (!has(e) && !has(r)) return book?.popularity_checked_at ? 'checked, nothing found' : 'not checked';
  const ed = has(e) ? `${e.toLocaleString('en-US')} ${e === 1 ? 'edition' : 'editions'}` : 'editions unknown';
  const ra = has(r) ? `${r.toLocaleString('en-US')} ${r === 1 ? 'rating' : 'ratings'}` : 'ratings unknown';
  return `${ed} · ${ra}`;
}
